import React from 'react'
import {useRouteError} from 'react-router-dom'
import {LogOutLink} from './components/logOutLink/LogOutLink'

export type ErrorPageProps = {
  showLogout?: boolean
}

export function ErrorPage(props: ErrorPageProps) {
  const error = useRouteError() as any
  console.error(error)
  return (
    <div id="error-page">
      <h1>Oops!</h1>
      <p>Sorry, an unexpected error has occurred.</p>
      <p>
        <i>{error.statusText || error.message}</i>
      </p>
      {props.showLogout && <LogOutLink />}
    </div>
  )
}
